import { InjectionToken } from '@angular/core';

export const WIDGET_BUILDER_TAB = new InjectionToken<WidgetBuilderTab>('');

export interface WidgetBuilderTab {
    canDeactivate(): boolean;
}
